import {React, Component, Container, _} from 'utils';
import { Campaigns, Creators } from 'model';

class DeleteCampaign extends Component {
	
	handleDelete = (event) => {

		event.preventDefault();
		
		var selected = Campaigns.getState().selected;
		Creators.deleteCampaign(selected);
	}

	static getStores() {
		return [Campaigns];
	}

	static calculateState(state, props) {
		var state = Campaigns.getState();

		return {
			selected: state.selected
		}
	}
	
	render() {
		var { selected } = this.state;

		if(selected) {
			return <div>
				<form className="form-horizontal" onSubmit={this.handleDelete}>
					<div className="form-group">
						<div className="col-md-12 text-center">
							{_('Sigurno želite obrisati ') } <strong>{selected.title}</strong>?
						</div>
					</div>
					<div className="text-right">
						<input type="submit" className="btn btn-danger btn-block" value={_('Obriši')} />
					</div>
				</form>
			</div>;
		} else {
			return null;
		}

	}
}

const container = Container.create(DeleteCampaign, { withProps: true });
export default container;


// WEBPACK FOOTER //
// ./src/modules/campaign/DeleteCampaign.js